import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { EnableEscCloseDirective, UiAutofocusDirective, UiButtonComponent } from '@ui';
import { VehicleGroupsModel } from '@models/vehicle-groups.model';

@Component({
  selector: 'app-group-name-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    UiButtonComponent,
    A11yModule,
    UiAutofocusDirective,
  ],
  templateUrl: './vehicle-group-name-dialog.component.html',
  styleUrl: './vehicle-group-name-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [EnableEscCloseDirective]
})
export class VehicleGroupNameDialogComponent implements OnInit {
  public readonly nameControl = new FormControl('', [Validators.required]);
  public readonly continueClicked = new Subject<string>();
  public duplicateName = '';
  public titleKey = 'VEHICLE_GROUPS.NAME_DIALOG.CREATE_TITLE';
  public submitKey = 'COMMON.CONTINUE';

  public constructor(
    private readonly dialogRef: MatDialogRef<VehicleGroupNameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data?: VehicleGroupsModel.GroupNameDialogData,
  ) {}

  public ngOnInit(): void {
    if (this.data?.initialName != null && this.data.initialName !== '') {
      this.nameControl.setValue(this.data.initialName);
    }
    if (this.data?.titleKey) {
      this.titleKey = this.data.titleKey;
    }
    if (this.data?.submitKey) {
      this.submitKey = this.data.submitKey;
    }
  }

  public onContinue(): void {
    const name = this.nameControl.value?.trim();
    if (!name) {
      return;
    }
    this.continueClicked.next(name);
  }

  public onCancel(): void {
    this.dialogRef.close(null);
  }

  public setDuplicateError(name: string): void {
    this.nameControl.setErrors({ duplicate: true });
    this.duplicateName = name;
  }
}
